import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { LaborData } from '.'

export class ActivityType extends EnumEntity {
  @Type(() => LaborData)
  laborData: LaborData[]
}
